import React from 'react';
import { FileText, Play, Brain, Share2 } from 'lucide-react';

const ToolsOverview = ({ isDarkMode }) => {
  const tools = [
    { icon: FileText, title: 'PDF & Image OCR', desc: 'Extract text from any document or photo' },
    { icon: Play, title: 'Audio & Video AI', desc: 'Transcribe lectures and videos instantly' },
    { icon: Brain, title: 'AI Question Solver', desc: 'Step-by-step solutions for any problem' },
    { icon: Share2, title: 'Export Anywhere', desc: 'PDF, Google Classroom, WhatsApp' }
  ];

  return (
    <section data-testid="section-tools-overview" className={`py-16 md:py-24 ${isDarkMode ? 'bg-[#131C2E]' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className={`inline-block text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>Powerful Tools</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
            Everything You Need to Learn & Teach
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {tools.map((tool, i) => (
            <div key={i} className={`p-6 rounded-xl text-center ${isDarkMode ? 'bg-slate-800/50 border border-slate-700' : 'bg-slate-50 border border-slate-200'}`}>
              <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl mb-4 ${isDarkMode ? 'bg-purple-900/50' : 'bg-purple-100'}`}>
                <tool.icon className={`w-7 h-7 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
              </div>
              <h3 className="text-lg font-bold mb-2">{tool.title}</h3>
              <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{tool.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsOverview;
